import { useCallback, useState } from 'react'

const initialDialogStates = {
  findHotelByInvoiceId: false,
  addPayment: false,
  billingContacts: false,
  invoiceSent: false,
  addCustomCharge: false
}

export const useBillingDialogsManager = () => {
  const [dialogs, setDialogs] = useState(initialDialogStates)

  const openDialog = useCallback(dialogName => {
    setDialogs(prevDialogs => ({ ...prevDialogs, [dialogName]: true }))
  }, [])

  const closeDialog = useCallback(dialogName => {
    setDialogs(prevDialogs => ({ ...prevDialogs, [dialogName]: false }))
  }, [])

  const setDialogVisibility = useCallback((dialogName, isVisible) => {
    setDialogs(prevDialogs => ({ ...prevDialogs, [dialogName]: isVisible }))
  }, [])

  return {
    dialogs,
    openDialog,
    closeDialog,
    setDialogVisibility
  }
}
